// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"85953fbd","208":"ef8b5d06","315":"20787dd1","409":"cfa77c90","631":"57630bfe","771":"a1041516","774":"2ea7b9f3","787":"51b15cd7"}[chunkId] + ".chunk.js";
};